module.exports = __webpack_public_path__ + "departed-n-f-days-ago.png?d38b9e8d52994eb799620db813da5b67";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/departed-n-f-days-ago.png
// module id = 482
// module chunks = 0